import { LogisticTask, Box } from "../";
import LogisticTaskFooter from "./LogisticTaskFooter-component";
import LogisticTimeLine from "./LogisticTimeLine-component";
import { Theme } from "@sloth-system/styled-utils";
import React from "react";
import Typography from "../Typography";
import Stack from "../Stack";

enum TaskTypeEnum {
  collection = "collection",
  delivery = "delivery",
}

enum TaskStatusEnum {
  unassigned = "unassigned",
  assigned = "assigned",
  loaded = "loaded",
  "not-present" = "not-present",
  done = "done",
  canceled = "canceled",
}
interface LogesticTaskInOrder {
  id: number;
  address_text: string;
  period: Period;
  task_type: TaskTypeEnum;
  status: TaskStatusEnum;
  address_longitude: number;
  address_latitude: number;
  driver?: Driver;
  in_person?: boolean;
}
interface Driver {
  id: number;
  first_name: string;
  last_name: string;
  cellphone: string;
}

interface Period {
  id: number;
  date: Date;
  title: string;
  start: string;
  end: string;
}
interface PropTypes {
  list: LogesticTaskInOrder[];
  status?: string;
  onCanceled?: (item) => void;
  onAdd?: () => void;
  onReschedule?: (item) => void;
  theme: Theme;
  icons: {
    active: React.ReactNode;
    normal: React.ReactNode;
    time?: React.ReactNode;
  };
  permission?: (permissionKey: string) => boolean;
  taskLink?: (order_id: number) => string | undefined;
  policy?: string;
  children?: React.ReactNode;
}

const set_collection_placeholder_task = {
  address_latitude: 0,
  address_longitude: 0,
  address_text: "محل مورد نظر خود را برای جمع آوری انتخاب کنید.",
  driver: undefined,
  id: 0,
  period: {
    id: 0,
    date: "",
    start: "",
    end: "",
    title: "زمان جمع آوری را انتخاب کنید.",
  },
  status: "",
  task_type: TaskTypeEnum.collection,
};
const delivery_placeholder_task = {
  id: 0,
  address_text: "پس از آماده‌‌شدن پیامک دریافت می‌کنید",
  period: { id: 0, date: "", title: "", start: "", end: "" },
  task_type: TaskTypeEnum.delivery,
  status: "done",
  address_longitude: 0,
  address_latitude: 0,
  driver: undefined,
};
const set_delivery_placeholder_task = {
  address_latitude: 0,
  address_longitude: 0,
  address_text: "محل مورد نظر خود را برای تحویل انتخاب کنید.",
  driver: undefined,
  id: 0,
  period: {
    id: 0,
    date: "",
    start: "",
    end: "",
    title: "زمان تحویل را انتخاب کنید.",
  },
  status: "",
  task_type: TaskTypeEnum.delivery,
};

function actions_as_task(status?: string) {
  let output: any = [];
  if (!status) {
    return [set_collection_placeholder_task];
  } else {
    if (
      [
        "submitted_by_crm",
        "submitted_by_customer",
        "collection_canceled",
        "collection_not_present",
      ].includes(status)
    ) {
      output.push(set_collection_placeholder_task);
    }
    if (
      ["delivery_canceled", "delivery_not_present", "work_done"].includes(
        status
      )
    ) {
      output.push(set_delivery_placeholder_task);
    }
    if (
      [
        "collected",
        "ready_to_collect",
        "submitted_by_customer",
        "submitted_by_crm",
        "collection_canceled",
        "collection_not_present",
        "unwrapped",
        "in_progress",
      ].includes(status)
    ) {
      output.push(delivery_placeholder_task);
    }
    return output;
  }
}

function LogisticsHistory(props: PropTypes) {
  let disabled = ["canceled_by_customer", "canceled_by_system"].includes(
    props.status || ""
  );
  let actions = disabled ? [] : actions_as_task(props.status);

  if (disabled && props.list.length === 0) {
    return (
      <Stack distribution="center">
        <Typography>سرویس حمل و نقلی ثبت نشده است.</Typography>
      </Stack>
    );
  }
  return (
    <Box>
      <LogisticTimeLine
        theme={props.theme}
        icon={props.icons.normal}
        activeIcon={props.icons.active}
      >
        {props.list?.map((item) => {
          let active: boolean =
            item.status === "unassigned" || item.status === "assigned";
          return (
            <LogisticTask
              key={item.id}
              active={active}
              data={item}
              taskLink={
                props.permission &&
                props.taskLink &&
                props.permission("add_task")
                  ? `${props.taskLink(item.id)}`
                  : undefined
              }
              footer={
                <LogisticTaskFooter
                  onCanceled={() => {
                    if (props.onCanceled) {
                      props.onCanceled(item);
                    }
                  }}
                  onReschedule={() => {
                    if (props.onReschedule) {
                      props.onReschedule(item);
                    }
                  }}
                  data={item}
                  policy={props.policy}
                  logisticTimeIcon={props.icons.time}
                  inPerson={item.in_person}
                />
              }
              theme={props.theme}
            />
          );
        })}
        {actions.map((action_task, index) => {
          let actionable = action_task.status !== "done";
          return (
            <LogisticTask
              key={index}
              data={action_task}
              theme={props.theme}
              active={actionable}
              line={actionable}
              footer={
                <LogisticTaskFooter
                  onAdd={actionable ? props.onAdd : undefined}
                  data={action_task}
                  policy={props.policy}
                />
              }
            />
          );
        })}
      </LogisticTimeLine>
    </Box>
  );
}

export default LogisticsHistory;
